import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_be73014c from 'nuxt_plugin_plugin_be73014c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_626ab134 from 'nuxt_plugin_sentryserver_626ab134' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_069d80a8 from 'nuxt_plugin_sentryclient_069d80a8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_51ce92d4 from 'nuxt_plugin_plugin_51ce92d4' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_4435e454 from 'nuxt_plugin_pluginclient_4435e454' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_439e7f5e from 'nuxt_plugin_pluginserver_439e7f5e' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_axios_a60d3d20 from 'nuxt_plugin_axios_a60d3d20' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vueyoutube_6da200de from 'nuxt_plugin_vueyoutube_6da200de' // Source: ../../../plugins/vue-youtube.js (mode: 'all')
import nuxt_plugin_vuesoundcloudplayer_9ce26f68 from 'nuxt_plugin_vuesoundcloudplayer_9ce26f68' // Source: ../../../plugins/vue-soundcloud-player.js (mode: 'client')
import nuxt_plugin_jarallaxclient_0ddafbf1 from 'nuxt_plugin_jarallaxclient_0ddafbf1' // Source: ../../../plugins/jarallax.client.js (mode: 'client')
import nuxt_plugin_vueplyr_9db9a11c from 'nuxt_plugin_vueplyr_9db9a11c' // Source: ../../../plugins/vue-plyr (mode: 'client')
import nuxt_plugin_heapclient_5868a480 from 'nuxt_plugin_heapclient_5868a480' // Source: ../../../plugins/heap.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"fr"},"titleTemplate":"%s","title":"Danse Swing à Grenoble | Lindy Hop, Charleston, Balboa","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Cours de Swing (Lindy Hop, Charleston) à Grenoble, Saint Martin d'Hères. Danse à deux, fun, technique, soirées, stages, ateliers, pratique, acrobatie"},{"hid":"image","name":"image","content":"https:\u002F\u002Fmecanikaswing.fr\u002Fmecanikaswing-logo.png"},{"hid":"google-site-verification","name":"google-site-verification","content":"Ba4QihQSpous0YTMWjEVTy9Vg8njqNjaOuTaazUUxLk"},{"hid":"itemprop:name","itemprop":"name","content":"Danse Swing à Grenoble | Lindy Hop, Charleston, Balboa, Acrobatie"},{"hid":"itemprop:description","itemprop":"description","content":"Cours de Swing (Lindy Hop, Charleston) à Grenoble, Saint Martin d'Hères. Danse à deux, fun, technique, soirées, stages, ateliers, pratique, acrobatie"},{"hid":"itemprop:image","itemprop":"image","content":"https:\u002F\u002Fmecanikaswing.fr\u002Fmecanikaswing-logo.png"},{"hid":"og:title","property":"og:title","content":"Danse Swing à Grenoble | Lindy Hop, Charleston, Balboa"},{"hid":"og:description","property":"og:description","content":"Cours de Swing (Lindy Hop, Charleston) à Grenoble, Saint Martin d'Hères. Danse à deux, fun, technique, soirées, stages, ateliers, pratique, acrobatie"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fmecanikaswing.fr\u002Fmecanikaswing-logo.png"},{"hid":"og:image:alt","property":"og:image:alt","content":"Mécanika'Swing logo"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fmecanikaswing.fr"},{"hid":"og:site_name","property":"og:site_name","content":"Swing - Mécanika'Swing"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:locale","property":"og:locale","content":"fr_FR"},{"hid":"fb:admins","property":"fb:admins","content":"1265093133616900"},{"name":"msapplication-TileColor","content":"#9c27b0"},{"name":"theme-color","content":"#9c27b0"},{"hid":"twitter:card","property":"twitter:card","content":"summary"},{"hid":"twitter:site","property":"twitter:site","content":"@mecanikaswing"},{"hid":"twitter:title","property":"twitter:title","content":"Danse Swing à Grenoble | Lindy Hop, Charleston, Balboa"},{"hid":"twitter:description","property":"twitter:description","content":"Cours de Swing (Lindy Hop, Charleston) à Grenoble, Saint Martin d'Hères. Danse à deux, fun, technique, soirées, stages, ateliers, pratique, acrobatie"},{"hid":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fmecanikaswing.fr\u002Fmecanikaswing-logo.png"},{"hid":"twitter:image","property":"twitter:image:alt","content":"Mécanika'Swing Swing logo"}],"script":[{"src":"https:\u002F\u002Fapp.mailjet.com\u002Fpas-nc-embedded-v1.js","type":"text\u002Fjavascript","defer":true,"body":true}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Fms-favicon.png"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google-analytics.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":true},{"rel":"stylesheet","type":"text\u002Fcsss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Eczar:400,700|Yatra+One|Special+Elite|Arvo:400,700|Roboto:400,700|Josefin+Sans:wght@700&display=swap","defer":true},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_be73014c === 'function') {
    await nuxt_plugin_plugin_be73014c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_626ab134 === 'function') {
    await nuxt_plugin_sentryserver_626ab134(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_069d80a8 === 'function') {
    await nuxt_plugin_sentryclient_069d80a8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_51ce92d4 === 'function') {
    await nuxt_plugin_plugin_51ce92d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_4435e454 === 'function') {
    await nuxt_plugin_pluginclient_4435e454(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_439e7f5e === 'function') {
    await nuxt_plugin_pluginserver_439e7f5e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_a60d3d20 === 'function') {
    await nuxt_plugin_axios_a60d3d20(app.context, inject)
  }

  if (typeof nuxt_plugin_vueyoutube_6da200de === 'function') {
    await nuxt_plugin_vueyoutube_6da200de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesoundcloudplayer_9ce26f68 === 'function') {
    await nuxt_plugin_vuesoundcloudplayer_9ce26f68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_jarallaxclient_0ddafbf1 === 'function') {
    await nuxt_plugin_jarallaxclient_0ddafbf1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueplyr_9db9a11c === 'function') {
    await nuxt_plugin_vueplyr_9db9a11c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_heapclient_5868a480 === 'function') {
    await nuxt_plugin_heapclient_5868a480(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
